module.exports = __webpack_public_path__ + "img/shixi03.c2a075bc.png";